import React, { useEffect, useState } from "react";

import { AgGridReact } from 'ag-grid-react';
import classNames from 'classnames';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-balham.css';
import css from './style.scss';

const ContactSearchGridWrapper = ({ gridProps, agGridFields, data, onGridReady, size, remaining, gridRootRef }) => {

    return (
        <>
            <div ref={gridRootRef} className={classNames("ag-theme-balham", css.grid, css.modernGrid)} style={{
                display: 'flex',flexDirection: 'column',
                height: `${size == null || remaining <= 0 ? 'calc( 100% - 10px )' : 'calc( 100% - 70px )'}`}}>
                <AgGridReact 
                    suppressHorizontalScroll={false}

                    domLayout="normal"
                    suppressRowClickSelection 
                    {...gridProps} 
                    getRowId={(params) => params?.data?.id}
                    columnDefs={agGridFields}
                    rowData={data}
                    onGridReady={(params) => onGridReady(params)}
                />
            </div>
        </>
    );
};

export default ContactSearchGridWrapper;